import { render, staticRenderFns } from "./AddPointFilter.vue?vue&type=template&id=81e38e46&"
import script from "./AddPointFilter.vue?vue&type=script&lang=ts&"
export * from "./AddPointFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports